import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import FormCheckboxGroupField from "../../fields/checkboxFieldGroup";
import DynamicFieldLabel from "./DynamicFieldLabel";
import { FormFieldOption } from "../../fields/types";
import SchemaService from "../SchemaService";
import { useStaticData } from "../../../../context/staticData";
import FieldAlias from "../enums/FieldAlias";
import { useCopies } from "shared/hooks/useCopies";
import { getOptionsWithConflictTagType } from "shared/form/util";
import { FormValueType } from "../types/SchemaField";

/**
 * @name CheckboxGroupFieldWrapper
 * @param props
 * @constructor
 * @todo RR JS check 'withSelectAll' attribute condition
 */
export default function CheckboxGroupFieldWrapper(props: DynamicFieldConfigType) {
  const staticData = useStaticData();
  const copies = useCopies();
  const options: Array<FormFieldOption> = React.useMemo(() => {
    const parsedOptions = SchemaService.parseOptions({ schemaObj: props.schemaObj, staticData: staticData });
    return getOptionsWithConflictTagType({
      options: parsedOptions,
      conflictValue: props.schemaObj.conflictValue as FormValueType,
      initialValue: props.schemaObj.value
    });
  }, [props.schemaObj, staticData]);

  const disabledOptions = React.useMemo(() => {
    if (props.schemaObj.alias === FieldAlias.ORGANIZATION_PARTICIPANT_TYPES) {
      return props.schemaObj.options?.filter(option => option.disabled).map(opt => opt.id);
    } else {
      return [];
    }
  }, [props.schemaObj.alias, props.schemaObj.options]);

  const disabledCheckboxTitle = React.useMemo(
    () =>
      props.schemaObj.alias === FieldAlias.ORGANIZATION_PARTICIPANT_TYPES
        ? copies.get("rpt.cant.be.removed")
        : undefined,

    [copies, props.schemaObj.alias]
  );

  return (
    <FormCheckboxGroupField
      name={props.schemaObj.id}
      label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
      disabled={props.schemaObj.disabled}
      options={options}
      required={props.schemaObj.mandatory}
      validate={props.validationFn}
      withSelectAll={props.schemaObj.displaySelectAll || false}
      disabledCheckboxTitle={disabledCheckboxTitle}
      disabledOptions={disabledOptions}
      conflictValue={props.schemaObj.conflictValue}
      fieldOptionViewType={props.schemaObj.fieldOptionViewType}
      className={props.schemaObj.className}
      fullWidth={true}
      indented={props.schemaObj.indented}
    />
  );
}
